import React, { useEffect } from "react";
import { ErrorBlock } from 'antd-mobile'

const Error404 = () => {
  return (
    <ErrorBlock
      fullPage
      style={{
        '--image-width-full-page': 'auto',
        '--image-height-full-page': '1.5rem'
      }}
      className='glibalErrorBlock'
      image={require('../static/images/pic_251x150_404@3x.png')}
      description={'内容不存在'}
      title={null}
    />
  );
};

export default Error404;
